<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('setting.language')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="items">
      <div
        v-for="item in languageOptions"
        :key="item.value"
        class="item van-hairline--bottom"
        @click="changeLang(item.value, $event)"
      >
        <div class="flex_center">
          <img :src="item.icon" :alt="item.label" class="lang_icon"/>
          <div class="info">{{ item.label }}</div>
        </div>
        <div class="selected_mark" v-if="lang == item.value">✓</div>
      </div>
    </div>
  </div>
</template>
  
  <script>


import { Toast } from "vant";
/** 与 main.js 中 VueI18n messages 的 locale 键保持一致 */
const SUPPORTED_LANGS = ['en', 'zh', 'kr', 'ja', 'ar', 'es', 'de', 'pt', 'it'];
const LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English', icon: '/img/en.png' },
  { value: 'zh', label: '中文繁体', icon: '/img/zh.png' },
  { value: 'kr', label: '한국어', icon: '/img/kr.png' },
  { value: 'ja', label: '日本語', icon: '/img/ja.png' },
  { value: 'ar', label: 'العربية', icon: '/img/ar.png' },
  { value: 'es', label: 'Español', icon: '/img/es.png' },
  { value: 'de', label: 'Deutsch', icon: '/img/de.png' },
  { value: 'pt', label: 'Português', icon: '/img/pt.png' },
  { value: 'it', label: 'Italiano', icon: '/img/it.png' }
];

export default {
  name: "Language",
  data() {
    return {
      lang: localStorage.getItem("lang") || "en",
      source: '',
      languageOptions: LANGUAGE_OPTIONS
    };
  },
  created() {
    this.normalizeStoredLang();
    this.replaceLang()
  },
  mounted() {
    this.source=this.$route.params.type
  },
  methods: {
    /** 若本地存储了已移除或不支持的语言代码，则回退为英语 */
    normalizeStoredLang() {
      const stored = localStorage.getItem("lang");
      if (!stored || SUPPORTED_LANGS.indexOf(stored) === -1) {
        this.lang = "en";
        localStorage.setItem("lang", "en");
        this.$i18n.locale = "en";
      } else {
        this.lang = stored;
        this.$i18n.locale = stored;
      }
    },
    back(){
      if (this.source == 'setting') {
        this.$router.push({ path: '/Mine' });
        return;
      }
      return window.history.back();
    },
    replaceLang() {
      this.$http({
        method: "get",
        url: "replaceLang",
        data: {
          lang: this.lang,
        },
      }).then((res) => {
      console.log(res,11)
      });
    },
    changeLang(lang) {
      
      Toast.loading({
        // mask: true,
        duration: 200,
      });
      this.lang = lang;
      this.$i18n.locale = lang;
      this.replaceLang()
      localStorage.setItem("lang", lang);
   
      if (this.source=='setting'){
        this.$router.push({ path: '/Mine' });
      }else{
        this.$router.go(-1);
      }
    }
  }

};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.nav-bar{
  background: #1f1c1f;
  height: 100px;

}
.container .items {
  background: linear-gradient(120deg, #212121, #313131);
  font-size: 30px;
  color: #f3c7a2;
  padding: 20px 25px 30px;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  box-sizing: border-box;
}
.container .items .item {
  padding: 18px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom-width: 10px;
  min-height: 84px;
}
.container .items .van-hairline--bottom::after {
  border-bottom-width: 3px;
  padding: 10px 0;
}
.container .sign-out {
  margin: 500px 20px 0;
  height: 100px;
  line-height: 100px;
  border-radius: 50px;
  color: #fff;
  font-size: 40px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(270deg, #e6c3a1, #7e5678);
}
.container .item .desc {
  font-size: 30px;
  font-weight: 700;
  color: #979799;
}
.container .item .right {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.flex_center {
  display: flex;
  align-items: center;
  min-width: 0;
}
.flex_center img {
  width: 60px;
  height: auto;
  margin-right: 20px;
}
.info {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 520px;
}
.selected_mark {
  min-width: 32px;
  text-align: right;
  color: #f3c7a2;
  font-size: 34px;
  font-weight: bold;
}
</style>
